var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "table",
    {
      staticClass:
        "screen-control-planning-table__table screen-control-planning-table__header",
    },
    [
      _c("thead", { staticClass: "v-data-table-header" }, [
        _c(
          "tr",
          { class: _vm.classTr },
          [
            !_vm.noRoomCol
              ? _c(
                  "th",
                  {
                    class: [
                      _vm.ClvrScreenControlTable.CELL_TH_CSS,
                      _vm.ClvrScreenControlTable.ROOM_TH_CSS,
                    ],
                  },
                  [
                    _c("clvr-screen-control-header-cell", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("screenControl:screenControl-room")) +
                          "\n                "
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.filteredHeaders, function (header) {
              return _c(
                "th",
                {
                  key: header.name,
                  class: [
                    _vm.ClvrScreenControlTable.CELL_TH_CSS,
                    _vm.CELL_COMPONENTS_MAPPING?.[header.name]?.[
                      "classNameCellHeader"
                    ] ?? _vm.ClvrScreenControlTable.DEFAULT_CELL_TD_CSS,
                  ],
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(header.label) +
                      "\n            "
                  ),
                ]
              )
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      !_vm.hideData
        ? _c(
            "tbody",
            { ref: "tbodyScreenControl" },
            [
              _vm._l(_vm.groupOperations, function (operations, groupIndex) {
                return _vm._l(operations, function (operation, index) {
                  return _c(
                    "tr",
                    {
                      key: "group-" + groupIndex + "-op-" + index,
                      class: _vm.getOperationLineClass(
                        operation,
                        groupIndex,
                        index
                      ),
                    },
                    [
                      !_vm.noRoomCol && index === 0
                        ? _c(
                            "th",
                            {
                              class: [
                                _vm.ClvrScreenControlTable.ROOM_TH_CSS,
                                groupIndex % 2 === 0
                                  ? _vm.ClvrScreenControlTable.ROOM_BLUE_CSS
                                  : _vm.ClvrScreenControlTable.ROOM_GREEN_CSS,
                              ],
                              attrs: { rowspan: operations.length },
                            },
                            [
                              index === 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "screen-control-planning-table__room",
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(_vm.getRoomName(operations)) +
                                          "\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(
                        _vm.filteredHeaders,
                        function (header, headerIndex) {
                          return _c(
                            "td",
                            {
                              key: _vm.getHeaderKeyName(
                                groupIndex,
                                index,
                                headerIndex
                              ),
                              class: [
                                _vm.ClvrScreenControlTable.CELL_TD_CSS,
                                _vm.CELL_COMPONENTS_MAPPING?.[header.name]?.[
                                  "classNameCellBody"
                                ] ??
                                  _vm.ClvrScreenControlTable
                                    .DEFAULT_CELL_TD_CSS,
                              ],
                            },
                            [
                              _c("clvr-screen-control-row-cell", {
                                class:
                                  _vm.ClvrScreenControlTable
                                    .CELL_TD_CONTENT_CSS,
                                attrs: {
                                  interventionData: operation,
                                  "cell-type": header.name,
                                },
                              }),
                            ],
                            1
                          )
                        }
                      ),
                    ],
                    2
                  )
                })
              }),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }